<script lang="ts">
	import { format } from '../../../services/i18n';
	import {
		ActionsContainer,
		IconButton,
		ListMenuCard,
		ListMenuCardV2,
	} from '@Shelly/shelly-design-system/index';

	import { edit } from 'src/stores/ui/edit_lists';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import type { ISceneObj } from '../../../types/SceneType';
	import { mapLegacyColorToToken } from 'src/helpers/new-layout-helpers';

	import GroupStatus from './GroupStatus.svelte';
	import ControlGroupDirection from 'src/components/Controls/Group/ControlGroupDirection.svelte';
	import ControlGroupOnOff from 'src/components/Controls/Group/ControlGroupOnOff.svelte';
	import ControlGroupThermostat from 'src/components/Controls/Group/ControlGroupThermostat.svelte';
	import { updateItemStoreAfterPulse } from 'src/helpers/add-entity-helpers';

	export let item: any;
	export let load_image_from: (path: string) => string | undefined;
	export let onCardClick: (item: ISceneObj) => void;
	export let onCardDelete: (item: ISceneObj) => void;
	export let onCardEdit: (item: ISceneObj) => void;
	export let hasMissingDevice: boolean;

	$: if (item?.new && $edit) {
		// Remove pulse when added new item and we are in edit mode
		updateItemStoreAfterPulse(item, 'groups');
	}
</script>

{#if $showNewLayout}
	<ListMenuCardV2
		title={item.name}
		image={item.image && load_image_from(item.image)}
		backgroundColor={mapLegacyColorToToken(item.backgroundColor)}
		editMode={$edit}
		selected={item.id === $sidePanelStateCombined?.id}
		isFocusable={false}
		on:click={() => onCardClick(item)}
		on:handle-drag-start
		on:handle-drag-end
		pulseAnimation={item?.new}
		on:pulse-animation-end={async () => {
			updateItemStoreAfterPulse(item, 'groups');
		}}
	>
		<GroupStatus
			{item}
			{hasMissingDevice}
			size="m"
			slot="main"
			on:label-click={() => onCardClick(item)}
		/>
		<svelte:fragment slot="right">
			{#if item.type === 'roller'}
				<ControlGroupDirection group={item} variant="listMenuCard" />
			{:else if item.type === 'thermostat'}
				<ControlGroupThermostat group={item} variant="listMenuCard" />
			{:else}
				<ControlGroupOnOff group={item} variant="listMenuCard" />
			{/if}
		</svelte:fragment>
	</ListMenuCardV2>
{:else}
	<ListMenuCard
		title={item.name}
		image={item.image && load_image_from(item.image)}
		backgroundColor={item.backgroundColor}
		editMode={$edit}
		selected={item.id === $sidePanelStateCombined?.id}
		on:click={() => onCardClick(item)}
		isFocusable={false}
		pulseAnimation={item?.new}
		on:pulse-animation-end={async () => {
			updateItemStoreAfterPulse(item, 'groups');
		}}
	>
		<GroupStatus
			{item}
			{hasMissingDevice}
			size="m"
			slot="main"
			on:label-click={() => onCardClick(item)}
		/>
		<svelte:fragment slot="right">
			{#if $edit}
				<ActionsContainer orientation="vertical">
					<IconButton
						on:mousedown
						on:touchstart
						on:mouseup
						on:touchend
						icon="fas fa-up-down-left-right"
						slot="first"
						dndHandle
						aria-label={$format('aria_drag_group', {
							default: 'Drag group',
						})}
					/>
					<IconButton
						icon="fas fa-pen"
						slot="second"
						on:click={(e) => onCardEdit(item)}
						aria-label={$format('aria_edit_group', {
							default: 'Edit group',
						})}
					/>
					<IconButton
						icon="fas fa-trash"
						variant="danger"
						slot="third"
						on:click={(e) => onCardDelete(item)}
						aria-label={$format('aria_delete_group', {
							default: 'Delete group',
						})}
					/>
				</ActionsContainer>
			{:else if item.type === 'roller'}
				<ControlGroupDirection group={item} variant="listMenuCard" />
			{:else if item.type === 'thermostat'}
				<ControlGroupThermostat group={item} variant="listMenuCard" />
			{:else}
				<ControlGroupOnOff group={item} variant="listMenuCard" />
			{/if}
		</svelte:fragment>
	</ListMenuCard>
{/if}
